<div class="__text-xeditor" style="position: relative;"
     [ngStyle]="{'width.px':params.width}"
>
    <span [innerHtml]="params.description"></span>
</div>
